import { render, staticRenderFns } from "./SeatbeltVehiclePage.vue?vue&type=template&id=8a543204&"
import script from "./SeatbeltVehiclePage.vue?vue&type=script&lang=js&"
export * from "./SeatbeltVehiclePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports